<template>
  <div class="social-buttons">
    <div class="social-heading">
      {{$t('nav.social_heading')}}
    </div>
    <ul>
      <li class="social-facebook"><a href="https://www.facebook.com/SchneiderElectricUS/?brand_redir=248492308506194" target="_blank"><FacebookIcon/></a></li>
      <li class="social-twitter"><a href="https://twitter.com/schneiderelec" target="_blank"><TwitterIcon/></a></li>
      <li class="social-google"><a href="https://plus.google.com/+schneiderelectric" target="_blank"><GoogleIcon/></a></li>
      <li class="social-linkedin"><a href="https://www.linkedin.com/company/schneider-electric/" target="_blank"><LinkedInIcon/></a></li>
      <li class="social-youtube"><a href="https://www.youtube.com/user/SchneiderCorporate" target="_blank"><YoutubeIcon/></a></li>
      <li class="social-blog"><a href="https://blog.schneider-electric.com/" target="_blank"><BlogIcon/></a></li>
    </ul>
  </div>
</template>
<script>
import FacebookIcon from '../assets/social-facebook.svg'
import TwitterIcon from '../assets/social-twitter.svg'
import BlogIcon from '../assets/social-blog.svg'
import GoogleIcon from '../assets/social-google-plus.svg'
import LinkedInIcon from '../assets/social-linkedin.svg'
import YoutubeIcon from '../assets/social-youtube.svg'

export default {
  name: 'ShareButtons',
  components: {
    TwitterIcon,
    FacebookIcon,
    BlogIcon,
    GoogleIcon,
    LinkedInIcon,
    YoutubeIcon
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';

.social-buttons {
  width: 100%;
  padding: 16px 34px;
  @media(min-width: $screen-sm-min) {
    padding: 16px 24px;
  }
  background: $white;
  .social-heading {
    color: $grey;
    font-size: px2rem(10);
    text-transform: uppercase;
    border-bottom: 1px solid #e7e6e6;
    padding-bottom: 10px;
    letter-spacing: .04rem;
  }
  > ul {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    li {
      margin-bottom: 0;
      svg {
        width: 65%;
        height: 65%;
        margin-top: 7px;
        fill: $white;
        @media (min-width: 768px) {
          margin-top: 4px;
        }
      }
      &.social-facebook {
        svg {
          // height: 100%;
        }
        &:hover a { background: #3B5998; }
      }
      &.social-twitter:hover {
        a { background: #1DA1F2; }
      }
      &.social-linkedin:hover {
        a { background: #0077B5; }
      }
      &.social-youtube:hover {
        a { background: #FF0000; }
      }
      &.social-google:hover {
        a { background: #D34836; }
      }
      &.social-blog:hover {
        a { background: #3DCD58; }
      }
      a {
        transition: .2s background;
        display: flex;
        width: 36px;
        height: 36px;
        cursor: pointer;
        @media(min-width: $screen-sm-min) {
          width: 24px;
          height: 24px;
        }
        background: #b2b2b2;
        border-radius: 0;
        color: #fff;
        line-height: 24px;
        text-align: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SocialButtons.vue